import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  height: 100%;
  justify-content: space-evenly;

  h1,
  span {
    text-align: center;
  }

  span.description {
    font-weight: normal;
    font-size: 1rem;
    line-height: 132.5%;
    text-align: center;
    letter-spacing: -0.5px;
    margin: 0px;
    color: #888888;
  }
`;
